import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700, fontSize: '2.5rem' },
    h2: { fontWeight: 700, fontSize: '2rem' },
    h3: { fontWeight: 700, fontSize: '1.75rem' },
    h4: { fontWeight: 700, fontSize: '1.5rem' },
    h5: { fontWeight: 600, fontSize: '1.25rem' },
    h6: { fontWeight: 600, fontSize: '1rem' },
    subtitle1: { fontWeight: 500, fontSize: '1rem' },
    subtitle2: { fontWeight: 500, fontSize: '0.875rem' },
    body1: { fontWeight: 400, fontSize: '1rem' },
    body2: { fontWeight: 400, fontSize: '0.875rem' },
    button: {
      fontWeight: 500,
      fontSize: '0.875rem',
      textTransform: 'none',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: '"Lato", sans-serif',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"Lato", sans-serif',
          fontWeight: 500,
          textTransform: 'none',
          borderRadius: '8px',
          transition: 'all 0.2s ease-in-out',

          // Do not override default text buttons to preserve main page styling
          '&.MuiButton-text': {
            // No overrides here to protect main page layout
          },

          // Only style the following scoped buttons
          '&.goals-overview-button': {
            backgroundColor: 'var(--clr-mindly-purple)',
            color: 'var(--clr-theme-white)',
            fontWeight: 600,
            padding: '6px 1rem',
            '&:hover': {
              backgroundColor: 'var(--clr-mindly-purple-hover)',
            },
          },

          '&.reminder-button': {
            backgroundColor: 'var(--clr-mindly-purple)',
            color: 'var(--clr-theme-white)',
            fontWeight: 600,
            textTransform: 'capitalize',
            width: '200px',
            '&:hover': {
              backgroundColor: 'var(--clr-mindly-purple-hover)',
            },
          },

          '&.reminder-button.small': {
            width: '90%',
            fontSize: '0.85rem',
            height: '36px',
            padding: '4px 16px',
            margin: '0 auto',
            whiteSpace: 'nowrap',
          },
        },
      },
    },
  },
});

export default theme;
